import { Popup, PopupBody, PopupFooter } from '../controls';
import { OnHoverTooltip } from '../common';
import { Table } from '../bidding/common/table';
import { ColumnBuilder } from '../bidding/common/table/columns/column-builder/ColumnBuilder';
import { IColumnDefinition } from '../bidding/common/table/types/ColumnDefinition';
import { constants } from '../../constants';
import { SyndicateContact } from '../../types/loan/Loan';
import { nameUtils } from '../../utils';

const getTableColumns = () => {
    const columnDefinitions: IColumnDefinition<SyndicateContact>[] = [{
            columnKey: 'fullName',
            renderColumnHeaderContent: () => 'Full Name',
            renderColumnContent: ({ firstName, lastName }) => {
                const fullName = nameUtils.getFullName(firstName, lastName);
                return (
                    <OnHoverTooltip overlay={fullName} disabled={!(firstName || lastName)}>
                        <span>{fullName}</span>
                    </OnHoverTooltip>
                );
            },
            className: 'data-list-cell-lg',
        }, {
            columnKey: 'title',
            renderColumnHeaderContent: () => 'Title',
            renderColumnContent: ({ title }) => {
                if (title) {
                    return (
                        <OnHoverTooltip overlay={title} placement="bottom">
                            <span>{title}</span>
                        </OnHoverTooltip>
                    );
                }
                return constants.emptyPlaceholder;
            },
            headerClassName: 'data-list-cell-md data-list-cell-full-name',
            bodyClassName: 'data-list-cell-md',
        }, {
            columnKey: 'email',
            renderColumnHeaderContent: () => 'Email',
            renderColumnContent: ({ email }) =>
                email ? (
                    <OnHoverTooltip overlay={email}>
                        <a href={`mailto:${email}`}>{email}</a>
                    </OnHoverTooltip>
                ) : constants.emptyPlaceholder,
            className: 'data-list-cell-xl',
        }, {
            columnKey: 'office',
            renderColumnHeaderContent: () => 'Office',
            renderColumnContent: ({ officePhone }) =>
                officePhone || constants.emptyPlaceholder,
            className: 'data-list-cell-sm',
        }, {
            columnKey: 'mobile',
            renderColumnHeaderContent: () => 'Mobile',
            renderColumnContent: ({ mobilePhone }) =>
                mobilePhone || constants.emptyPlaceholder,
            className: 'data-list-cell-sm',
        },
    ];

    return columnDefinitions.map(c => new ColumnBuilder(c));
};

export interface SyndicateContactsPopupProps {
    arrangerLegalName: string;
    contacts: SyndicateContact[];
    onClose: () => void;
}

export function SyndicateContactsPopup({ arrangerLegalName, contacts, onClose }: SyndicateContactsPopupProps) {
    if (!contacts.length) return null;

    return (
        <Popup
            modalClass="modal-syndicate-contacts"
            title="Syndicate Contacts"
            renderTitle={<span className="name-tag">{arrangerLegalName}</span>}
            onClose={onClose}
            renderInBody
        >
            <PopupBody>
                <Table dataItems={contacts} columns={getTableColumns()} className="data-list-striped" />
            </PopupBody>
            <PopupFooter>
                <button className="btn btn-ghost" onClick={onClose}>
                    Close
                </button>
            </PopupFooter>
        </Popup>
    );
}
